<template>
  <div>
    <b-card class="p-0 filter-card rounded-lg">
      <b-row>
        <b-col
          cols="12"
          class="d-flex align-items-center justify-content-between"
        >
          <h3 class="ml-1 mb-2">
            فرق العمل - الفلاتر
          </h3>
          <div>
            <b-button
              variant="primary"
              size="sm"
              class="ml-1"
              :to="{ name: 'team_works_create' }"
            >
              <feather-icon
                icon="PlusIcon"
                size="14"
                class="mr-50"
              />
              إضافة
            </b-button>
            <b-button
              variant="outline-secondary"
              size="sm"
              @click="clearFilters"
            >
              <feather-icon
                icon="XCircleIcon"
                size="14"
                class="mr-50"
              />
              مسح
            </b-button>
          </div>
        </b-col>

        <!-- Employee filters -->
        <b-col cols="12">
          <h5 class="ml-1 mt-1">
            المسؤولين
          </h5>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <b-form-group label="المهندس المسؤول">
            <v-select
              v-model="filter.technical_responsible_id"
              :options="employeesOptions"
              :reduce="val => val.id"
              :get-option-label="o => o.full_name"
              :clearable="true"
              dir="rtl"
              @search="onEmployeeSearch"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <b-form-group label="مسؤول الاتفاقية">
            <v-select
              v-model="filter.office_agreement_responsible_id"
              :options="employeesOptions"
              :reduce="val => val.id"
              :get-option-label="o => o.full_name"
              :clearable="true"
              dir="rtl"
              @search="onEmployeeSearch"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <b-form-group label="مسؤول المعاينة">
            <v-select
              v-model="filter.office_inspection_responsible_id"
              :options="employeesOptions"
              :reduce="val => val.id"
              :get-option-label="o => o.full_name"
              :clearable="true"
              dir="rtl"
              @search="onEmployeeSearch"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="4"
        >
          <b-form-group label="مسؤول الرسم">
            <v-select
              v-model="filter.office_drawing_responsible_id"
              :options="employeesOptions"
              :reduce="val => val.id"
              :get-option-label="o => o.full_name"
              :clearable="true"
              dir="rtl"
              @search="onEmployeeSearch"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <b-form-group label="مسؤول QC">
            <v-select
              v-model="filter.qc_responsible_id"
              :options="employeesOptions"
              :reduce="val => val.id"
              :get-option-label="o => o.full_name"
              :clearable="true"
              dir="rtl"
              @search="onEmployeeSearch"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="4"
        >
          <b-form-group label="السائق">
            <v-select
              v-model="filter.driver_id"
              :options="employeesOptions"
              :reduce="val => val.id"
              :get-option-label="o => o.full_name"
              :clearable="true"
              dir="rtl"
              @search="onEmployeeSearch"
            />
          </b-form-group>
        </b-col>

        <!-- Location -->
        <b-col cols="12">
          <h5 class="ml-1 mt-1">
            الموقع
          </h5>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="filter.governorate_id"
            :options="governorates"
            :reduce="val => val.id"
            :get-option-label="o => o.name_ar || o.name || o.name_local"
            dir="rtl"
            :clearable="true"
            placeholder="المحافظة"
            @search="onGovernorateSearch"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="filter.center_id"
            :options="centers"
            :reduce="val => val.id"
            :get-option-label="o => o.name_ar || o.name || o.name_local"
            dir="rtl"
            :clearable="true"
            :disabled="!filter.governorate_id"
            placeholder="المركز"
            @search="onCenterSearch"
          />
        </b-col>
        <b-col
          cols="12"
          md="2"
        >
          <v-select
            v-model="filter.city_id"
            :options="cities"
            :reduce="val => val.id"
            :get-option-label="o => o.name_ar || o.name || o.name_local"
            dir="rtl"
            :clearable="true"
            :disabled="!filter.center_id"
            placeholder="المدينة"
            @search="onCitySearch"
          />
        </b-col>
        <b-col
          cols="12"
          md="2"
        >
          <v-select
            v-model="filter.district_id"
            :options="districts"
            :reduce="val => val.id"
            :get-option-label="o => o.name_ar || o.name || o.name_local"
            dir="rtl"
            :clearable="true"
            :disabled="!filter.city_id"
            placeholder="الحي"
            @search="onDistrictsSearch"
          />
        </b-col>
        <b-col
          cols="12"
          md="2"
        >
          <v-select
            v-model="filter.village_id"
            :options="villages"
            :reduce="val => val.id"
            :get-option-label="o => o.name_ar || o.name || o.name_local"
            dir="rtl"
            :clearable="true"
            :disabled="!filter.district_id"
            placeholder="القرية"
            @search="onVillageSearch"
          />
        </b-col>
      </b-row>
    </b-card>

    <b-card class="rounded-lg">
      <div
        v-if="loadList"
        class="text-center"
      >
        <b-spinner variant="primary" />
      </div>

      <b-table
        v-else
        striped
        responsive
        :items="rows"
        :fields="fields"
        show-empty
        empty-text="لا توجد بيانات"
      >

        <template #cell(inspection_teams)="d">
          <b-badge variant="light-info">
            {{ (d.item.inspection_teams || []).length }}
          </b-badge>
        </template>
        <template #cell(actions)="d">
          <b-link
            :to="{ name: 'team_works_details', params: { id: d.item.id } }"
            class="text-primary"
          >
            <feather-icon
              icon="EyeIcon"
              size="16"
            />
          </b-link>
          <b-link
            class="text-primary mr-1"
            :to="{ name: 'team_works_edit', params: { id: d.item.id } }"
          >
            <feather-icon
              icon="EditIcon"
              size="16"
            />
          </b-link>
          <b-link
            class="text-danger"
            @click="confirmDelete(d.item)"
          >
            <feather-icon
              icon="TrashIcon"
              size="16"
            />
          </b-link>
        </template>
      </b-table>

      <b-pagination
        v-if="paginateEnabled && meta"
        v-model="pageProxy"
        align="center"
        :total-rows="meta.total"
        :per-page="meta.per_page"
        @change="onPageChange"
      />
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BTable,
  BSpinner,
  BPagination,
  BBadge,
  BLink,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'

export default {
  name: 'TeamWorksList',
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BTable,
    BSpinner,
    BPagination,
    BBadge,
    BLink,
    vSelect,
  },
  computed: {
    ...mapGetters({
      list: 'teamWorks/list',
      loadList: 'teamWorks/loadList',
      employees: 'employees/employees',
      governorates: 'governorates/governorates',
      centers: 'centers/centers',
      cities: 'cities/cities',
      districts: 'districts/districts',
      villages: 'villages/districts',
    }),
    employeesOptions() {
      return this.employees && this.employees.data ? this.employees.data : []
    },
    rows() {
      return this.list && this.list.data ? this.list.data : []
    },
    meta() {
      return this.list && this.list.meta ? this.list.meta : null
    },
    paginateEnabled() {
      return this.filter.paginate !== false
    },
    pageProxy: {
      get() {
        return this.meta && this.meta.current_page ? this.meta.current_page : 1
      },
      set() {},
    },

  },
  data() {
    return {
      fields: [
        { key: 'technical_responsible.full_name', label: 'المهندس' },
        // { key: 'office_inspection_responsible.full_name', label: 'المعاينة' },
        // { key: 'office_drawing_responsible.full_name', label: 'الرسم' },
        // { key: 'qc_responsible.full_name', label: 'QC' },
        { key: 'driver.full_name', label: 'السائق' },
        { key: 'governorate.name_ar', label: 'المحافظة' },
        { key: 'center.name_ar', label: 'المركز' },
        { key: 'city.name_ar', label: 'المدينة' },
        { key: 'district.name_ar', label: 'الحي' },
        { key: 'village.name_ar', label: 'القرية' },
        { key: 'inspection_teams', label: 'عدد فريق المعاينة' },
        { key: 'actions', label: 'إجراءات', style: 'width: 100px;' },
      ],
      filter: {
        paginate: true,
        per_page: 15,
        page: 1,
        sort_by: 'id',
        sort_direction: 'desc',

        technical_responsible_id: null,
        office_agreement_responsible_id: null,
        office_inspection_responsible_id: null,
        office_drawing_responsible_id: null,
        qc_responsible_id: null,
        driver_id: null,

        governorate_id: null,
        center_id: null,
        city_id: null,
        district_id: null,
        village_id: null,
      },
      searchTimeout: null,
    }
  },
  watch: {
    'filter.technical_responsible_id': function () { this.onFilterChanged() },
    'filter.office_agreement_responsible_id': function () { this.onFilterChanged() },
    'filter.office_inspection_responsible_id': function () { this.onFilterChanged() },
    'filter.office_drawing_responsible_id': function () { this.onFilterChanged() },
    'filter.qc_responsible_id': function () { this.onFilterChanged() },
    'filter.driver_id': function () { this.onFilterChanged() },

    'filter.governorate_id': function (v) {
      this.filter.center_id = null
      this.filter.city_id = null
      this.filter.district_id = null
      this.filter.village_id = null
      if (v) this.$store.dispatch('centers/list', { query: { governorate_id: v } })
      this.onFilterChanged()
    },
    'filter.center_id': function (v) {
      this.filter.city_id = null
      this.filter.district_id = null
      this.filter.village_id = null
      if (v) this.$store.dispatch('cities/list', { query: { center_id: v } })
      this.onFilterChanged()
    },
    'filter.city_id': function (v) {
      this.filter.district_id = null
      this.filter.village_id = null
      if (v) this.$store.dispatch('districts/list', { query: { city_id: v } })
      this.onFilterChanged()
    },
    'filter.district_id': function (v) {
      this.filter.village_id = null
      if (v) this.$store.dispatch('villages/list', { query: { district_id: v } })
      this.onFilterChanged()
    },
    'filter.village_id': function () { this.onFilterChanged() },
  },
  mounted() {
    this.$store.dispatch('governorates/list', {})
    this.$store.dispatch('employees/listEmployees', { query: {} })
    this.fetch()
  },
  methods: {
    cleanQuery(obj) {
      const q = {}
      Object.keys(obj || {}).forEach(k => {
        const v = obj[k]
        if (v === null || v === undefined) return
        if (typeof v === 'string' && v.trim() === '') return
        q[k] = v
      })
      return q
    },
    fetch() {
      const query = this.cleanQuery({ ...this.filter })
      this.$store.dispatch('teamWorks/fetchList', { query })
    },
    onFilterChanged() {
      this.filter.page = 1
      this.fetch()
    },
    onPageChange(p) {
      this.filter.page = p
      this.fetch()
    },
    clearFilters() {
      this.filter = {
        paginate: true,
        per_page: (this.filter && this.filter.per_page) ? this.filter.per_page : 15,
        page: 1,
        sort_by: 'id',
        sort_direction: 'desc',

        technical_responsible_id: null,
        office_agreement_responsible_id: null,
        office_inspection_responsible_id: null,
        office_drawing_responsible_id: null,
        qc_responsible_id: null,
        driver_id: null,

        governorate_id: null,
        center_id: null,
        city_id: null,
        district_id: null,
        village_id: null,
      }
      this.$store.dispatch('governorates/list', {})
      this.fetch()
    },
    onEmployeeSearch(search, loading) {
      clearTimeout(this.searchTimeout)
      if (loading) loading(true)
      this.searchTimeout = setTimeout(() => {
        const query = search ? { search } : {}
        this.$store.dispatch('employees/listEmployees', { query }).finally(() => {
          if (loading) loading(false)
        })
      }, 300)
    },
    onGovernorateSearch(search, loading) {
      clearTimeout(this.searchTimeout)
      if (loading) loading(true)
      this.searchTimeout = setTimeout(() => {
        if (search) {
          const params = search ? { search } : {}
          this.$store.dispatch('governorates/list', params).finally(() => {
            if (loading) loading(false)
          })
        }
      }, 300)
    },
    onCenterSearch(search, loading) {
      clearTimeout(this.searchTimeout)
      if (loading) loading(true)
      this.searchTimeout = setTimeout(() => {
        if (search) {
          const params = search ? { search } : {}
          this.$store.dispatch('centers/list', params).finally(() => {
            if (loading) loading(false)
          })
        }
      }, 300)
    },
    onCitySearch(search, loading) {
      clearTimeout(this.searchTimeout)
      if (loading) loading(true)
      this.searchTimeout = setTimeout(() => {
        if (search) {
          const params = search ? { search } : {}
          this.$store.dispatch('cities/list', params).finally(() => {
            if (loading) loading(false)
          })
        }
      }, 300)
    },
    onDistrictsSearch(search, loading) {
      clearTimeout(this.searchTimeout)
      if (loading) loading(true)
      this.searchTimeout = setTimeout(() => {
        if (search) {
          const params = search ? { search } : {}
          this.$store.dispatch('districts/list', params).finally(() => {
            if (loading) loading(false)
          })
        }
      }, 300)
    },
    onVillageSearch(search, loading) {
      clearTimeout(this.searchTimeout)
      if (loading) loading(true)
      this.searchTimeout = setTimeout(() => {
        if (search) {
          const params = search ? { search } : {}
          this.$store.dispatch('villages/list', params).finally(() => {
            if (loading) loading(false)
          })
        }
      }, 300)
    },
    confirmDelete(item) {
      this.$swal({
        title: 'هل أنت متأكد؟',
        text: 'سيتم حذف فريق العمل!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'نعم، احذف!',
        cancelButtonText: 'إلغاء',
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch('teamWorks/delete', { id: item.id }).then(() => {
            this.fetch()
          })
        }
      })
    },
  },
}
</script>
